/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectPlan from 'modules/me/select-cloud-backup-plan';
import CurrentCloundBackupPlanCard from './index/current-plan-card';
import PlanDetailsCard from './index/plan-details-card';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import Notice from 'components/notice';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import BillingDetailsCard from './index/billing-details-card';

/**
 * Style dependencies
 */
import './styles.scss';

const CloudBackup = (props) => {
    return (
        <Box>
            <DocumentHead title='Billing - Manage Cloud Backup Plan - Tower Systems' />
            <Topbar title='Cloud Backup Plan' subTitle='Manage your Cloud Backup plan' selected='cloud-backup'>
            </Topbar>
            <Main padding='xxlarge'>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Subscription Details'
                            description='Cloud Backup plan details.'
                        />
                        <AnnotatedSection.Content>
                            <CurrentCloundBackupPlanCard />
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
    }),
    {},
)(CloudBackup);
